import { useQuery } from '@tanstack/react-query';

import { fetchMe } from 'apis/restaurant-api/merchant-admin/user/api';

const useCurrentUser = () => {
  const { data, error } = useQuery(['/v1/user/me'], () => fetchMe());
  return { data, error };
};

export default useCurrentUser;
